import { useTranslation } from 'react-i18next'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import { sortingOptions } from './constants'
import * as Styles from './styles'

const SortingSettingsSection = ({ sortingValue, onChangeSorting, title, description, label }) => {
  const { t } = useTranslation()

  return (
    <Styles.Section>
      <Text type="titleM">{title}</Text>
      <Text type="bodyMRegular">{description}</Text>
      <ComboBox
        label={label}
        menuItems={sortingOptions.map(o => ({ ...o, label: t(o.label) }))}
        value={sortingValue}
        handleChange={e => onChangeSorting(e.target.value)}
      />
    </Styles.Section>
  )
}

export default SortingSettingsSection
